import * as types from './constants';

const initialState = {
  data: {},
  getLoading: false,
  updateLoading: false,
  errors_api: {}
};

const actions = {
  // Get Batch Message Template
  [types.GET_BATCH_MESSAGE_TEMPLATE_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_BATCH_MESSAGE_TEMPLATE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      getLoading: false
    };

    return { ...data };
  },

  [types.GET_BATCH_MESSAGE_TEMPLATE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Update Batch Message Template
  [types.UPDATE_BATCH_MESSAGE_TEMPLATE_REQUEST]: state => {
    const data = {
      ...state,
      updateLoading: true
    };

    return { ...data };
  },

  [types.UPDATE_BATCH_MESSAGE_TEMPLATE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      updateLoading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.UPDATE_BATCH_MESSAGE_TEMPLATE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      updateLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.UPDATE_BATCH_MESSAGE_TEMPLATE_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

